var calledLoad = false;
export var ProductWidget = {
    init: function () {
        var loadWidget = function () {
            if (calledLoad) {
                return;
            }
            calledLoad = true;
            var script = document.createElement('script');
            script.src = 'https://widget-product.kontur.ru/widget/loader?' + 'product=&type=service';
            setTimeout(function () { return document.getElementsByTagName('head')[0].appendChild(script); });
        };
        loadWidget();
    },
};
